window.addEventListener('load', () => {
  // DOM element references
  const formElement               = document.querySelector('.page-product-form');
  const productId                 = formElement?.getAttribute('data-product-id');
  const productType               = formElement?.getAttribute('data-product-type');
  const metaDataDiv               = document.getElementById('meta-data');
  const collectionProdArray       = document.querySelectorAll('.product-item');
  const spinner                   = document.querySelector('.loader');
  const announcementItem          = document.querySelectorAll('announcement-bar-item');
  const relatedProductsContainer  = document.querySelector('.related-products-container');
  const colorTarget               = document.querySelector('.option-name-value');
  const inventoryTextItems        = document.querySelectorAll('.inventory');
  const productInventoryWrapper   = document.querySelector('product-inventory');



  var a_tags = document.getElementsByTagName('a');
  for (var i = 0; i < a_tags.length; i++) {
      if (a_tags[i].href.includes('/collections/') && !a_tags[i].href.includes('/products/')) {
          if (!a_tags[i].href.includes("?")) {
              a_tags[i].href += '?filter.v.availability=1';
          }
          if ( a_tags[i].href.includes("?")) {
              
          }
      }
  }


  // Accordion UI toggle
  document.addEventListener('click', function(event) {
    const acc = event.target.closest('.custom-accordion');
    if (!acc) return; // Click was not on a .custom-accordion
    
    acc.classList.toggle("active");
    const panel = acc.nextElementSibling;
    if (panel) {
      panel.style.display = (panel.style.display === "flex") ? "none" : "flex";
    }
  });


  // Inventory setup for single product
  if (metaDataDiv) {
    const mainId = metaDataDiv.getAttribute('data-main-product-id');
    if (mainId) {
      console.log('Set inventory single product');
    }
  }

  

  // Listen for variant change and trigger inventory and UI updates
  let initialVariantId = formElement?.getAttribute('data-variant-id');
  document.addEventListener('variant:changed', (event) => {
    if (productInventoryWrapper) {
      
      //productInventoryWrapper.style.opacity = '0';
    }
    
    //inventoryTextItems.forEach((e) => e.style.opacity = "0");

    
    const variant = event.detail.variant;
    console.log(variant.id);
    fetchAvailability(variant.id);
    // Optional: handleRelatedProducts(); can be triggered here if needed
  });

  // Initial load methods
  handleRelatedProducts();
  getMetafieldsFromExternal(productId);
  responsiveAnnouncementBarFix();
  fetchAvailability(initialVariantId);

  // Helper: get current product handle from URL
  function getCurrentHandle() {
    return window.location.pathname.split('/').filter(Boolean).pop();
  }

  // Fix layout issue for announcement bar on desktop
  function responsiveAnnouncementBarFix() {
    if (window.innerWidth > 768) {
      announcementItem.forEach(() => {
        console.log('responsiveAnnouncementBarFix');
      });
    }
  }

  // Fetch and display related products by SKU or GID
  async function handleRelatedProducts() {
    try {
      if (!metaDataDiv) throw new Error('Meta data div not found.');

      const identifier = metaDataDiv.getAttribute('data-identifier');
      const relatedObjectKeysArray = metaDataDiv.getAttribute('data-related-array');
      if (relatedObjectKeysArray) {
        if (identifier === "gid") {
          const relatedProductsIdentifier = JSON.parse(`[${relatedObjectKeysArray}]`);
          await queueProductsByGID(relatedProductsIdentifier);
        } else {
          const relatedProductsIdentifier = relatedObjectKeysArray.split(',');
          await queueProductsBySKU(relatedProductsIdentifier);
        }
      }

      mouseOverEffectForRelatedItems();
    } catch (error) {
      console.error('Error while handling related products: ', error);
    } finally {
      if (spinner) spinner.classList.add('hidden');
    }
  }

  // Fetch products via GID using Shopify GraphQL Storefront API
  async function queueProductsByGID(gidsArray) {
    const accessToken = "7d4f0c450ff92e9cac8ad756af0bc78c";
    gidsArray = gidsArray.map(id => `gid://shopify/Product/${id}`);

    fetch("https://one-opensky.myshopify.com/api/2023-10/graphql.json", {
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": accessToken,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        query: `
          {
            nodes(ids: ${JSON.stringify(gidsArray)}) {
              ... on Product {
                id
                title
                handle
                sku
                media(first: 3) {
                  nodes {
                    previewImage {
                      url
                    }
                  }
                }
                metafield(key: "farve", namespace: "global") {
                  value
                }
              }
            }
          }
        `
      })
    })
    .then(response => response.json())
    .then(data => {
      insertRelatedProducts(data);
      mouseOverEffectForRelatedItems();
    });
  }

  

  // Add hover color label for related products
  function mouseOverEffectForRelatedItems() {
    const relatedItems = document.querySelectorAll('.variant-related-color');
    if (!colorTarget) return;

    const originalColor = colorTarget.getAttribute('data-original-color');
    relatedItems.forEach((item) => {
      item.addEventListener('mouseover', (e) => {
        const color = e.target.getAttribute('data-colorvalue');
        if (color && color !== "null") colorTarget.textContent = color;
      });
      item.addEventListener('mouseleave', () => {
        colorTarget.textContent = originalColor;
      });
    });
  }

  // Fetch related products by SKU from custom API
  async function queueProductsBySKU(skus) {
    const apiUrl = 'https://shopify.api.nomilk.dev/one_open_sky/metafields.php';
    try {
      const skusParam = skus.join(',');
      const response = await fetch(`${apiUrl}?skus=${encodeURIComponent(skusParam)}`);
      const data = await response.json();
      const uniqueProducts = data
        .map(item => item.product)
        .filter((product, index, self) => index === self.findIndex(p => p.id === product.id));

        console.log('[INFO] - Products queued by SKU');
        console.log(uniqueProducts);
     // insertRelatedProductsCollection(uniqueProducts);
      insertRelatedProducts(uniqueProducts);
    } catch (error) {
      console.log('Error while queuing products by SKUs:', error);
    }
  }
  async function queueProductsBySKUCollection(skus, targetElement) {
    const apiUrl = 'https://shopify.api.nomilk.dev/one_open_sky/metafields.php';
    const skusParam = skus.join(',');
    const response  = await fetch(`${apiUrl}?skus=${encodeURIComponent(skusParam)}`);
    const data      = await response.json();

    const uniqueProducts = data
      .map(item => item.product)
      .filter((p, i, self) => i === self.findIndex(x => x.id === p.id));

    insertRelatedProductsCollection(uniqueProducts, targetElement);
  }

  // Insert product swatches for related products
  function insertRelatedProducts(data) {
    if (!relatedProductsContainer) return;

    console.log('[INFO] - Related products data');
    console.log(data);
    let products = data.data ? data.data.nodes : data;
    let identifier = data.data ? 'gid' : 'sku';
    const currentHandle = getCurrentHandle();
    let html = '';

    products.forEach((product) => {
      const productUrl = `/products/${product.handle}`;
      const imageUrl = identifier === 'gid'
        ? product.media.nodes[0]?.previewImage.url || ''
        : product.preview_image;
      const colorValue = identifier === 'gid' ? product.metafield.value : product.metafield;
      const isSelected = (currentHandle === product.handle) ? "selected" : "";

      html += `
        <a href="${productUrl}" data-sku="" data-colorvalue="${colorValue}" class="variant-related-color ${isSelected} variant-swatch__item">
          <span class="visually-hidden">${product.title}</span>
          <img src="${imageUrl}" alt="${product.title}" class="variant-swatch__image" loading="lazy"
            sizes="(max-width: 740px) 64px, 72px"
            srcset="${imageUrl} 64w, ${imageUrl} 72w, ${imageUrl} 128w, ${imageUrl} 144w, ${imageUrl} 192w, ${imageUrl} 216w">
        </a>
      `;
    });

    relatedProductsContainer.innerHTML = html;
  }


  function insertRelatedProductsCollection(products, target) {
    target.innerHTML = '';
    products.forEach(product => {
      const productUrl = `/products/${product.handle}`;
      const imageUrl = product.preview_image;
      const colorValue = product.metafield;
      const html = `
        <a href="${productUrl}" data-sku="" data-colorvalue="${colorValue}" class="collection-variant-swatch__item">
          <img src="${imageUrl}" alt="${product.title}" loading="lazy"
            sizes="(max-width: 740px) 64px, 72px"
            srcset="${imageUrl} 64w, ${imageUrl} 72w, ${imageUrl} 128w, ${imageUrl} 144w, ${imageUrl} 192w, ${imageUrl} 216w">
        </a>
      `;
    target.insertAdjacentHTML('beforeend', html);
  });
}
  // Render color swatches for collection grid
  // function insertRelatedProductsCollection(data) {
    
  //   const targets = document.querySelectorAll('.wrap-available-colors .target');
  //   targets.forEach((targetElement) => {
  //     targetElement.innerHTML = '';
  //     data.forEach((product) => {
  //       const productUrl = `/products/${product.handle}`;
  //       const imageUrl = product.preview_image;
  //       const colorValue = product.metafield;

  //       targetElement.innerHTML += `
  //         <a href="${productUrl}" data-sku="" data-colorvalue="${colorValue}" class="collection-variant-swatch__item">
  //           <img src="${imageUrl}" alt="${product.title}" loading="lazy"
  //             sizes="(max-width: 740px) 64px, 72px"
  //             srcset="${imageUrl} 64w, ${imageUrl} 72w, ${imageUrl} 128w, ${imageUrl} 144w, ${imageUrl} 192w, ${imageUrl} 216w">
  //         </a>
  //       `;
  //     });
  //   });
  // }

  // Inventory setup for product collection
  if (collectionProdArray.length) {
    collectionProdArray.forEach(prodItem => {
      const target = prodItem.querySelector('.wrap-available-colors .target');
      const skuStr = target?.getAttribute('data-colors');
      if (skuStr) {
        const skuArr = skuStr.split(',');
        queueProductsBySKUCollection(skuArr, target);   // pass the target here
      }
    });
  }

  // Trigger availability check for a variant ID
  function fetchAvailability(variantId) {
    if (!variantId) return;
    if(productType == "bundle-product") return;
    console.log('Not bundle');
    setInventoryQuantity(variantId);
  }

  // Query inventory data from PHP endpoint
  async function setInventoryQuantity(variantId) {
    const phpEndpoint = "https://shopify.api.nomilk.dev/one_open_sky/locations-data.php";
    try {
      const response = await fetch(phpEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ variantId }),
      });
      if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);

      const data = await response.json();
      
      console.log('__Stock data__');
      console.log(data);

      const edges = data.data?.productVariant?.inventoryItem?.inventoryLevels?.edges || [];
      if (!edges.length) return;

      handleStockData(edges);
    } catch (error) {
      console.error("Error fetching inventory data:", error);
    }
  }

function handleStockData(edges) {
  let webStock = 0;
  let hasCopenhagen = false;
  const locationMap = new Map();  

  // 1. Collect raw numbers
  edges.forEach(({ node }) => {
    const loc  = node.location.name;
    const qty  = node.quantities.find(q => q.name === 'on_hand')?.quantity || 0;

    locationMap.set(loc, qty);
    if (loc === 'København'){
      hasCopenhagen = true;
    } 
    else{
      webStock += qty;
    } 
  });

  // 2. Inject synthetic Herning row
  locationMap.set('Herning', webStock);

  // 3. Render every location once
  locationMap.forEach((qty, loc) =>
    renderAvailability(loc, qty, webStock)
  );

  // 4. Ensure København row exists even when API omitted it
  if (!hasCopenhagen) renderAvailability('København', 0, webStock);

  toggleWebshopInventory(webStock);
}

function renderAvailability(loc, qty, webStock) {
  const el = document.querySelector(
    `.store-availability-information[data-location-name="${loc}"]`
  );
  if (!el) return;

  el.setAttribute('data-on-hand', qty);

  const setVisible = (selector, show) =>
    el.querySelectorAll(selector).forEach(n => n.style.display = show ? 'flex' : 'none');

  // Rule A: show in-stock when positive for the location **or** aggregate web stock
  const isActive = qty > 0 || (loc === 'Herning' && webStock > 0);

  setVisible('.in-stock-display',  isActive);
  setVisible('.out-of-stock-display', !isActive);
  el.classList.toggle('active',   isActive);
  el.classList.toggle('inactive', !isActive);
}


// Update webshop UI depending on stock levels
function toggleWebshopInventory (webStock = 0) {
  /* --- DOM look-ups ------------------------------------------------------ */
  const addToCartBtn   = document.getElementById('AddToCart');
  const inventoryWrap  = document.querySelector('.product-form__inventory-wrapper');
  const inStockMsg     = document.querySelector('.inventory.in-webshop-stock');
  const outOfStockMsg  = document.querySelector('.inventory.not-in-webshop-stock');

  /* --- Basic guard-rail --------------------------------------------------- */
  if (!addToCartBtn || !inventoryWrap) return;   // nothing to update

  /* --- Calculate state ---------------------------------------------------- */
  const outOfStock = webStock <= 0;

    console.log('Not digital');
    /* --- Button ------------------------------------------------------------- */
    addToCartBtn.classList.toggle('inactive', outOfStock);
    addToCartBtn.innerText           = outOfStock ? 'Ikke på lager' : 'Tilføj til kurv';
    addToCartBtn.style.pointerEvents = outOfStock ? 'none'          : 'auto';
  

  /* --- Inventory messaging ------------------------------------------------ */
  if (inStockMsg)    inStockMsg.style.display    = outOfStock ? 'none' : 'flex';
  if (outOfStockMsg) outOfStockMsg.style.display = outOfStock ? 'flex' : 'none';
  inventoryWrap.style.opacity = '1';
}

// Insert fetched metafields into specification section
function insertMetafieldData(data) {
  const dataContainer = document.getElementById('product-specifications');
  const disallowedSpecificationsElement = document.getElementById('disallowed-product-specifications');
  if (!dataContainer || !disallowedSpecificationsElement) return;

  const specContainer = document.querySelector('.js-specifications');
  const allProdMeta = data.data.product.metafields.edges;
  const disallowedSpecifications = disallowedSpecificationsElement.getAttribute('data-disallowed-specifications')
    .split(',')
    .map(item => item.trim());

  allProdMeta.forEach((meta) => {
    const metaName = meta.node.definition ? meta.node.definition.name : 'N/A';
    const metaValue = meta.node.value;
    if (!disallowedSpecifications.includes(meta.node.key)) {
      createSpecElement(metaName, metaValue, specContainer);
    }
  });
}

// Render a single spec item
function createSpecElement(title, value, container) {
  if (!container) return;

  // Try to parse the value if it's a JSON array
  let cleanedValue = value;
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) {
      cleanedValue = parsed.join(', ');
    }
  } catch (e) {
    // Not a JSON stringified array; keep original value
  }

  const targetDiv = document.createElement('div');
  targetDiv.classList.add('specification');

  const titleDiv = document.createElement('div');
  titleDiv.classList.add('title');
  titleDiv.textContent = title;

  const valueDiv = document.createElement('div');
  valueDiv.classList.add('final');
  valueDiv.textContent = cleanedValue;

  targetDiv.append(titleDiv, valueDiv);
  container.appendChild(targetDiv);
}


// Fetch external metafield data
async function getMetafieldsFromExternal(productId) {
  if (!productId) return;
  try {
    const url = `https://shopify.api.nomilk.dev/one_open_sky/product-page-metadata.php?product_gid=${productId}`;
    const response = await fetch(url);
    const data = await response.json();
    insertMetafieldData(data);
  } catch (error) {
    console.error('Error fetching metafields:', error);
  }
}

const sizeGuidePop = document.querySelector('.pop-up-container');
const closePop = document.querySelector('.close');
const openPop = document.querySelector('.open-size-guide');

if (closePop && sizeGuidePop && openPop) {
  openPop.addEventListener('click', () => {
    sizeGuidePop.classList.remove('hidden');
  });

  closePop.addEventListener('click', () => {
    sizeGuidePop.classList.add('hidden');
  });
}


const fade = document.querySelector('.scroll-fade');
if(fade){
  const scrollable = document.querySelector('scrollable-content');
  
  function updateFade() {
    const scrollLeft = scrollable.scrollLeft;
    const maxScrollLeft = scrollable.scrollWidth - scrollable.clientWidth;
    
    if (scrollLeft >= maxScrollLeft - 1) {
      fade.style.opacity = '0';
    } else {
      fade.style.opacity = '1';
    }
  } 
  
  scrollable.addEventListener('scroll', updateFade);
  window.addEventListener('resize', updateFade);
  
  // Initial check
  updateFade();
}

const header = document.querySelector('store-header');
const headerOffset = header.offsetTop;
window.addEventListener('scroll', () => {
  const scrollPosition = window.scrollY || window.pageYOffset;

  if (scrollPosition > headerOffset) {
    // Header is now sticky / has moved from original position
    header.classList.add('is-sticky');
    // You can trigger any other logic here
  } else {
    // Header is at original position
    header.classList.remove('is-sticky');
  }
});

});

